import { ImageOptimizationContextProvider, ImageOptimizationComponent } from 'ui/contexts/ImageOptimizationContext';
import { RouteContextProvider } from 'ui/contexts/RouteContext';
import { UI_DectectKeyboard } from './DetectKeyboard/DetectKeyboard';
import styles from './Layout.module.scss';
import classNames from 'classnames';

type UI_LayoutProps = {
	children?: React.ReactNode;
	className?: string;
	router;
	imageOptimization: ImageOptimizationComponent;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const UI_Layout = ({ className, children, router, imageOptimization }: UI_LayoutProps) => {
	return (
		<div className={classNames(styles.Layout, className)}>
			<RouteContextProvider router={router}>
				<ImageOptimizationContextProvider imageOptimization={imageOptimization}>
					<UI_DectectKeyboard />
					{children}
				</ImageOptimizationContextProvider>
			</RouteContextProvider>
		</div>
	);
};
